import { Group } from 'redux/modules/auth/sign-in/reducer';
import { selectHasGroup } from 'redux/store/selectors';
import { useTypedSelector } from 'utils';

export const useHasGroup = (...groups: Group[]) => useTypedSelector(selectHasGroup(...groups));
export const useIsAdmin = () => useHasGroup(Group.admin);
export const useIsLBCoach = () => useHasGroup(Group.lbCoach);
